import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initTVMode } from './utils/tvMode';

// Suppress React Dev Server Red Error Overlay for benign stream AbortErrors & browser extension interrupts
if (typeof window !== 'undefined') {
  const isAbortError = (err) => {
    if (!err) return false;
    const msg = err?.message || String(err || '');
    const name = err?.name || '';
    return (
      name === 'AbortError' ||
      msg.includes('The user aborted a request') ||
      msg.includes('user aborted') ||
      msg.includes('signal is aborted') ||
      msg.includes('ResizeObserver loop limit exceeded') ||
      msg.includes('Script error.')
    );
  };

  window.addEventListener(
    'unhandledrejection',
    (event) => {
      if (isAbortError(event.reason)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  window.addEventListener(
    'error',
    (event) => {
      if (isAbortError(event.error) || isAbortError(event.message)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );
}

initTVMode();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && typeof event.reason.message === 'string') {
    if (event.reason.message.includes('A listener indicated an asynchronous response by returning true')) {
      event.preventDefault();
    }
  }
});

if ('serviceWorker' in navigator) {
  const swUrl = process.env.NODE_ENV === 'production' ? '/sw.js' : '/sw.js?dev=1';
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(swUrl).catch(() => {});
  });
}
